import React, { useState, forwardRef, useImperativeHandle } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const PageSizeDropdown = forwardRef(
  (
    {
      setPageSize,
      type = "first",
      defaultPage,
    }: {
      setPageSize: (size: number) => void;
      type?: string;
      defaultPage?: number;
    },
    ref
  ) => {
    const [currentPage, setCurrentPage] = useState<number>(defaultPage ?? 10);

    const onChange = (no: number) => {
      setCurrentPage(no);
      setPageSize(no);
    };

    useImperativeHandle(ref, () => ({
      onReset() {
        setCurrentPage(defaultPage ?? 10);
        setPageSize(defaultPage ?? 10);
      },
    }));

    return (
      <Menu as="div" className="relative inline-block text-left">
        <MenuButton className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-900 focus:outline-none">
          {currentPage || "Page Size"}
          <ChevronDownIcon className="-mr-1 ml-2 h-5 w-5" aria-hidden="true" />
        </MenuButton>

        <MenuItems
          anchor={type === "second" ? "bottom end" : "bottom start"}
          transition
          className="mt-2 w-[var(--button-width)] rounded-md shadow-lg bg-white ring-1 ring-primary-color ring-opacity-5 focus:outline-none z-50 origin-top transition ease-out duration-100 data-[closed]:scale-95 data-[closed]:opacity-0 data-[closed]:ease-in data-[closed]:duration-75"
        >
          <div className="py-1">
            {[10, 20, 50, 100].map((pageNo) => (
              <MenuItem key={pageNo}>
                <button
                  onClick={() => onChange(pageNo)}
                  className={classNames(
                    currentPage === pageNo ? "active-color" : "text-gray-700",
                    "block w-full text-left px-4 py-2 text-sm hover:text-white hover:bg-secondary-color cursor-pointer"
                  )}
                >
                  {pageNo}
                </button>
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Menu>
    );
  }
);

PageSizeDropdown.displayName = "PageSizeDropdown";

export default PageSizeDropdown;
